export default "__VITE_ASSET__CF6JM1ht__"